<div [ngStyle]="{'width': '90%'}" ngStyle.lt-lg="{'width': '100%'}" >

  <div style="margin-top:28px; font-size: 14px; font-weight: 500;">
    Retrofit description and associated costs
    <mat-divider [ngStyle]="{'width': '100%'}" ngStyle.lt-lg="{'width': '100%'}"></mat-divider>
  </div>
  <form [formGroup]="formReceipts" style="margin-top: 15px;">
    <div style="margin-top:20px; ">
      <div fxLayout="row" fxLayout.lt-md="column wrap">
        <div fxFlex="55%">
          {{retrofitTypeLabel}}&nbsp;*
        </div>
        <div fxFlex="45%">
          <mat-radio-group required id="retrofittype" name="retrofittype" formControlName="retrofittype" aria-label="Select an option">
            @for (retrofittype of filteredRetrofitTypeOptions; track retrofittype) {
             
              <mat-radio-button
                style="display: block; margin-left: 0;margin-top: -4.5%;"
                [value]="retrofittype.value"
                [checked]="retrofittype.value == application.retrofitType">
                {{ retrofittype.label }}
              </mat-radio-button>
              
            }
          </mat-radio-group>
          @if (onCheckReceiptControlValidators('retrofittype')) {
            <mat-error>
              Please choose a retrofit type
            </mat-error>
          }
        </div>
      </div>
    </div>
    <div style="margin-top:10px; ">
      <div fxLayout="row" fxLayout.lt-md="column wrap">
        <div fxFlex="55%">
          Does your retrofit require an Engineered Solution?&nbsp;*
        </div>
        <div fxFlex="45%" style="margin-top: -2%;">
          <mat-radio-group required id="engineeredtype" name="engineeredtype" formControlName="engineeredtype" aria-label="Select an option" >
            @for (type of receiptEngineeredTypeOptions; track type) {
              <mat-radio-button 
               
                [value]="type.value"
                [checked]="type.value == application.engineeredSolutionType">
                {{ type.label }}
              </mat-radio-button>
            }
          </mat-radio-group>
          @if (onCheckReceiptControlValidators('engineeredtype')) {
            <mat-error>
              Please select engineered solution type
            </mat-error>
          }
        </div>
      </div>
    </div>
    <div style="margin-top:15px; margin-bottom:-5px;">
      <div fxLayout="row" fxLayout.lt-md="column wrap">
        <div fxFlex="25">
          <mat-form-field appearance="outline" style="width:150px;">
            <mat-label>Permit Cost </mat-label>
            <input matInput (change)="setCostToZeroIfEmpty($event)" currencyMask min="0.01" required id="permitCostPostReceipt" name="permitCostPostReceipt"
              formControlName="permitCost" />
              @if (formReceipts.get('permitCost').hasError('required')) {
                <mat-error>
                  Permit Cost is required.
                </mat-error>
              }
              @if (formReceipts.get('permitCost').hasError('min')) {
                <mat-error>
                  Permit Cost must be zero or more.
                </mat-error>
              }
              <mat-hint>
                $0 or more
              </mat-hint>
            </mat-form-field>
          </div>
          <div fxFlex="25">
            <mat-form-field appearance="outline" style="width:150px;">
              <mat-label>Material Cost</mat-label>
              <input matInput (change)="setCostToZeroIfEmpty($event)" currencyMask min="0" id="materialCost" name="materialCost"
                formControlName="materialCost" />
                @if (formReceipts.get('materialCost').hasError('min')) {
                  <mat-error>
                    Material Cost cannot be negative.
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div fxFlex="25">
              <mat-form-field appearance="outline" style="width:150px;">
                <mat-label>Labor Cost</mat-label>
                <input matInput (change)="setCostToZeroIfEmpty($event)" currencyMask min="0" id="laborCost" name="laborCost" formControlName="laborCost" />
                @if (formReceipts.get('laborCost').hasError('min')) {
                  <mat-error>
                    Labor Cost cannot be negative.
                  </mat-error>
                }
              </mat-form-field></div>
              <div fxFlex="25">
                <mat-form-field appearance="outline" style="width:150px;">
                  <mat-label>Overhead & Profit</mat-label>
                  <input matInput (change)="setCostToZeroIfEmpty($event)" currencyMask min="0" id="overheadProfitCost" name="overheadProfitCost"
                    formControlName="overheadProfitCost" />
                    @if (formReceipts.get('overheadProfitCost').hasError('min')) {
                      <mat-error>
                        Overhead & Profit cannot be negative.
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                @if (!(application.programType === 700000004 || application.programType === 700000000)) {
                  <div fxFlex="25">
                    <mat-form-field appearance="outline" style="width:150px;">
                      <mat-label>Engineer Fee</mat-label>
                      <input matInput (change)="setCostToZeroIfEmpty($event)" currencyMask min="0" id="engineerFeeCost" name="engineerFeeCost"
                        formControlName="engineerFeeCost" />
                        @if (formReceipts.get('engineerFeeCost').hasError('min')) {
                          <mat-error>
                            Engineer Fee cannot be negative.
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  }
                </div>
              </div>



              <div style="margin-top: 12px; ">

                <mat-divider [ngStyle]="{'width': '100%'}" ngStyle.lt-lg="{'width': '100%'}"></mat-divider>
              </div>

              <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap.lt-md="3px" >

                <div fxFlex="25" style="margin-top: 15px; ">
                  <label for="totalamount"><strong>TOTAL COSTS</strong></label>
                </div>
                <div fxFlex="25"></div>
                <div fxFlex="25"></div>
                @if (!(application.programType === 700000004 || application.programType === 700000000)) {
                  <div fxFlex="25">
                  </div>
                }
                <div fxFlex="25" style="margin-top: 15px; ">
                  <div  style="width:150px;height:30px;text-align:right"><strong>{{ totalAmount() | currency  }}</strong></div>

                </div>
              </div>

              <div style="margin-bottom: 12px; ">
                <mat-divider [ngStyle]="{'width': '100%'}" ngStyle.lt-lg="{'width': '100%'}"></mat-divider>
              </div>
              <div>
                <button mat-raised-button color="primary" type="submit" (click)="onClickSaveReceiptsInfo()"
                  [disabled]="disableSaveButton && (formReceipts.pristine || formReceipts.invalid)">
                  SAVE
                </button>
              </div>
              @if (autoSaveIndicator) {
                <div style="margin-top: 12px;">
                  <mat-progress-bar mode="indeterminate" style="width: 300px;"></mat-progress-bar>
                </div>
              }
            </form>
          </div>
